<template>
    <van-tabs
            class="my_coupon_tabs"
            v-show="!filterShow"
            v-model="index"
            @click="handleClick"
            animated
            swipeable
            sticky
            :offsetTop="'1.15rem'">
        <van-tab title="可用券" style="height: 100%">
            <van-pull-refresh
                    style="height: 100%;overflow: scroll; -webkit-overflow-scrolling: touch;"
                    v-model="loading"
                    @refresh="onRefresh">
                <van-list
                        style=""
                        :loading="loading"
                        @load="onLoad"
                        :finished="finished[this.index]">
                    <div class="no-list" v-if="!validTicket.length">暂无数据</div>
                    <coupon-item v-else v-for="item in validTicket"
                                 :key="item.id"
                                 :coupon="item"
                                 @on-click="handleCouponClick(item)"></coupon-item>
                </van-list>
            </van-pull-refresh>
        </van-tab>
        <van-tab title="失效券">
            <van-pull-refresh
                    v-model="loading"
                    style="height: 100%;overflow: scroll"
                    @refresh="onRefresh">
                <van-list
                        :loading="loading"
                        @load="onLoad"
                        :finished="finished[this.index]">
                    <div class="no-list" v-if="!failureTicket.length"></div>
                    <coupon-item v-else v-for="item in failureTicket"
                                 :key="item.id"
                                 :coupon="item"
                                 @on-click="handleCouponClick(item)"></coupon-item>
                </van-list>
            </van-pull-refresh>
        </van-tab>

    </van-tabs>
</template>

<script>
    export default {
        name: "myCoupon",
        data() {
            return {
                //是否切换过
                isCut: [false, false],
                // 加载是否已完成
                finished: [false, false],
                // 页码
                pageNum: [1, 1],
                // 是否有下一页
                hasNextPage: [true, true],
                filterShow: false,
                loading: false,
                index: 0,
                validTicket: [],
                failureTicket: []
            }
        },
        components: {
            CouponItem: () => import('./components/couponItem')
        },
        watch: {
            index(val) {
                if (!this.isCut[val]) {
                    this.getList(true)
                }
            }
        },
        methods: {
            getList(empty) {
                let params = {
                    page: {
                        pageNum: this.pageNum[this.index],
                        pageSize: 10
                    },
                    params: {
                        logisticsCompanyId: this.$logisticsCompanyId,
                        // used: 0,
                        status: "0"
                    }
                };
                let url = "discount/coupon/list"
                if (this.index == 0) {
                    params.params.status = '1'
                    params.params.used = '0'
                } else {
                    params.params.status = '0'
                }
                this.loading = true;
                this.$axios.post(url, params).then(res => {
                    if (res.data.code === 200) {
                        let data = res.data.data;
                        if (empty) {
                            if (this.index == 0) {
                                this.validTicket = data.list
                            } else {
                                this.failureTicket = data.list
                            }
                            if (data.list.length > 0) {
                                this.isCut[this.index] = true
                            }
                        } else {
                            if (this.index == 0) {
                                this.validTicket = this.validTicket.concat(data.list);
                            } else {
                                this.failureTicket = this.failureTicket.concat(data.list);
                            }
                        }
                        // this.total[this.index] = data.params;
                        this.pageNum[this.index]++;
                        this.hasNextPage[this.index] = data.hasNextPage;
                        this.loading = false;
                        this.finished[this.index] = !data.hasNextPage;
                        // this.finished[this.index] = true;
                    }
                });
            },
            handleCouponClick(item) {
                item = JSON.stringify(item)
                this.$router.push({
                    path: "/couponDetails",
                    query: {item}
                })
            },
            // 上加载列表
            onLoad() {
                if (this.loading == false) this.getList(false);
            },
            handleClick(index) {
                // sessionStorage.setItem("myTrackingIndex", index)
                // if (index == 1) {
                //     document.getElementsByClassName('van-tab__pane')[0].style.height = '0'
                //     document.getElementsByClassName('van-tab__pane')[1].style.height = 'auto'
                // } else {
                //     document.getElementsByClassName('van-tab__pane')[1].style.height = '0'
                //     document.getElementsByClassName('van-tab__pane')[0].style.height = 'auto'
                // }
            },
            // 下拉刷新
            onRefresh() {
                this.pageNum[this.index] = 1;
                this.loading = true;
                // Object.keys(this.filterKey).forEach(key => {
                //     this.$set(this.filterKey, key, "");
                // });
                // this.filterKey.logisticsCompanyId = this.$logisticsCompanyId
                this.getList(true);
                this.refresh = true;
            },
        }
    }
</script>

<style lang="scss">
    .my_coupon_tabs {
        height: 100%;

        .van-tabs__content--animated {
            height: calc(100% - 1.15rem);
        }

        .van-tab__pane {
            height: 100%;
        }
    }

    .no-list {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.4rem;
        color: #8F8F8F;
    }

    .van-tabs__wrap {
        z-index: 8;
        height: 100%;
    }
</style>